"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _NumberInput = _interopRequireDefault(require("../NumberInput"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _arrayMerge = _interopRequireDefault(require("../../../helpers/arrayMerge"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { MINIMUM_CHARACTERS } from '../../../../constants/validation/validationRules'; // left for example purposes

/**
 * An input to be used when gathering money data
 * <br /> no default validator
 */
var MoneyInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MoneyInput, _React$PureComponent);

  var _super = _createSuper(MoneyInput);

  function MoneyInput(props) {
    var _this;

    _classCallCheck(this, MoneyInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "defaultValidationRules", {// BLUR: { [MINIMUM_CHARACTERS]: 9 }, // left for example purposes
    });

    _defineProperty(_assertThisInitialized(_this), "validateInput", function () {
      return _this.inputRef.current && _this.inputRef.current.validateInput();
    });

    var validationRules = _this.props.validationRules; // yes, as this stands now, validation rules will not get updated if this prop is updated later in the component lifecycle - this seems ok

    _this.composedValidationRules = (0, _lodash.mergeWith)(_this.defaultValidationRules, validationRules, _arrayMerge.default);
    _this.inputRef = _react.default.createRef();
    return _this;
  }

  _createClass(MoneyInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          allowNegative = _this$props.allowNegative,
          includeThousandsSeparator = _this$props.includeThousandsSeparator,
          integerLimit = _this$props.integerLimit,
          moneyType = _this$props.moneyType,
          prefix = _this$props.prefix,
          validationRules = _this$props.validationRules,
          props = _objectWithoutProperties(_this$props, ["allowNegative", "includeThousandsSeparator", "integerLimit", "moneyType", "prefix", "validationRules"]);

      return /*#__PURE__*/_react.default.createElement(_NumberInput.default, _extends({
        ref: this.inputRef,
        allowDecimal: moneyType === 'actual',
        allowNegative: allowNegative,
        prefix: prefix,
        includeThousandsSeparator: includeThousandsSeparator,
        integerLimit: integerLimit,
        leftIcons: [/*#__PURE__*/_react.default.createElement(_Icon.default, {
          dataTestId: "money-input-icon",
          iconName: "dollar-sign"
        })],
        inputType: "text",
        validationRules: this.composedValidationRules,
        zeroPadding: true
      }, props));
    }
  }]);

  return MoneyInput;
}(_react.default.PureComponent);

_defineProperty(MoneyInput, "propTypes", {
  /** Flag for allowing negative values */
  allowNegative: _propTypes.default.bool,

  /** Autofocus flag */
  autoFocus: _propTypes.default.bool,

  /** Children can be any valid node or array of valid nodes */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag used to disable the input */
  disabled: _propTypes.default.bool,

  /** Flag used for inidcating an error state for the input */
  error: _propTypes.default.string,

  /** Flag used to toggle the thousands separator (defaults to true) */
  includeThousandsSeparator: _propTypes.default.bool,

  /** Flag used to limit the length of the integer */
  integerLimit: _propTypes.default.number,

  /** Flag used for inidcating an error state for the input */
  label: _propTypes.default.string,

  /** Maximum accepted value for numeric inputs */
  maximumValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** Minimum accepted value for numeric inputs */
  minimumValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** precision of data to collect.  estimated is for whole dollars.  actual is for dollars and cents. */
  moneyType: _propTypes.default.oneOf(['estimated', 'actual']),

  /** name reference for label htmlFor */
  name: _propTypes.default.string,

  /** Allows a prefix for currency (or whatever you'd like) in the input field (defaults to '') */
  prefix: _propTypes.default.string,

  /** Additional validation rules to apply */
  validationRules: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]))),

  /** This is the storage location for the value of the input */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  // EVENTS

  /** Function to invoke on a blur event */
  onBlur: _propTypes.default.func,

  /** Function to invoke on a change event */
  onChange: _propTypes.default.func,

  /** Function to invoke on a click event */
  onClick: _propTypes.default.func,

  /** Function to invoke on a focus event */
  onFocus: _propTypes.default.func,

  /** Function to invoke on a keyUp event */
  onKeyUp: _propTypes.default.func
});

_defineProperty(MoneyInput, "defaultProps", {
  allowNegative: false,
  autoFocus: false,
  children: null,
  className: '',
  disabled: false,
  error: '',
  includeThousandsSeparator: true,
  integerLimit: null,
  label: '',
  maximumValue: null,
  minimumValue: null,
  name: '',
  prefix: '',
  validationRules: {},
  value: '',
  moneyType: 'estimated',
  // event handlers
  onBlur: function onBlur() {},
  onChange: function onChange(e) {
    return e.target.value;
  },
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onKeyUp: function onKeyUp() {}
});

var _default = MoneyInput;
exports.default = _default;